import styles from './style.module.css';
import api from "../../../api";
import { useEffect, useState } from 'react';
import Moment from 'react-moment';
import { FiDownloadCloud, FiCalendar } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const BulletinsSection = () => {
    const [bulletins, setBulletins] = useState([])
    const lastBulletins = bulletins.results?.slice(0, 4)
    useEffect(() => {
        api.getBulletins()
            .then((data) => {
                setBulletins(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        <div className={styles.bulletins_area}>
            <div className={styles.bulletins_area__cards}>
                {lastBulletins?.map((bulletin) => {
                    return (
                        <a href={bulletin.file} target="_blank" rel="noreferrer">
                            <div className={styles.card}>
                                <div className={styles.card__body}>
                                    <div className={styles.card__body__title}>
                                        {bulletin.about}
                                    </div>
                                    <div className={styles.card__body__date}>
                                        <span>
                                            №{bulletin.number} &nbsp;&nbsp;
                                            <FiCalendar />
                                            <Moment format="MM, YYYY">
                                                {bulletin.date}
                                            </Moment>
                                        </span>
                                    </div>
                                    <div className={styles.card__body__download}>
                                        <div className={styles.card__body__download__icon}>
                                            <FiDownloadCloud />
                                        </div>
                                        <span>скачать pdf</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    )
                }
                )}
            </div>
            <div className={styles.bulletins_area__info}>
                <div className={styles.row}>
                    <div className={styles.title}>
                        «Белая ромашка»
                    </div>
                    <div className={styles.content}>
                        Белая ромашка, также является открытой площадкой для пациентов излечившихся от туберкулеза, на которой они имеют возможность высказаться об их отношении к болезни, к процессу лечения и выздоровления...
                    </div>
                    <div className={styles.count}>Общее количество - # {bulletins.results?.length}</div>
                    <Link to='/bulletins/'><div className={styles.more}>Все номера...</div></Link>
                </div>
            </div>
        </div>
    );
}

export default BulletinsSection;